import { render, staticRenderFns } from "./editcomponent.vue?vue&type=template&id=5b42003e&scoped=true&"
import script from "./editcomponent.vue?vue&type=script&lang=js&"
export * from "./editcomponent.vue?vue&type=script&lang=js&"
import style0 from "./editcomponent.vue?vue&type=style&index=0&id=5b42003e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42003e",
  null
  
)

export default component.exports